import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'

import { FormRow, Col } from '../../../../../../../1stlog-ui/src/components/Bootstrap'
import { useField, FeedbackBadge } from '../../../../../../../1stlog-ui/src/components/Field'
import { useProducts, useSelectedProduct } from '../../../../Products'
import useOrderEntry from '../../../../useOrderEntry'

const validate = (value) =>
  value
    ? i18n.t('validation_please_select_product', 'Bitte wählen Sie eine Transportmöglichkeit aus')
    : undefined

const ProductValidation = (props) => {
  const { hide } = props

  const { isInternal } = useOrderEntry()
  const product = useSelectedProduct()
  const { products } = useProducts()

  const {
    input: { value: isProductInvalid, onChange: setIsProductInvalid },
    meta
  } = useField('validation.isProductInvalid', {
    raw: true,
    validate,
    subscribeAll: true
  })

  useEffect(() => {
    const newIsProductInvalid = !product && !isInternal
    if (!lodash.isEqual(isProductInvalid, newIsProductInvalid)) {
      setIsProductInvalid(newIsProductInvalid)
    }
  }, [product, isInternal])

  return (
    isProductInvalid &&
    !lodash.isEmpty(products) &&
    !hide && (
      <FormRow className="mb-2 mt-n2">
        <Col>
          <FeedbackBadge meta={meta} />
        </Col>
      </FormRow>
    )
  )
}

export default ProductValidation
